<template>
    <ul class="listBelo">
        <!-- @click.prevent="$parent.loadChart3 = spreads.mn ; $parent.loadChart2 = spreads.isinid" :class="($parent.loadChart2 == spreads.isinid)?'active':''" -->
         <template v-for="spreads,key,index in allIsins"  >
            <li class="mt-2" v-show="index<6">
                <div style="display: none;">
                    {{ isin = fetchPriceFeed[spreads.isinid] || {} }}
                </div>
                <div class="flagIcon d-flex align-items-center" v-if="spreads.type=='Forex'">
                    <span class="s1" >
                        <img :src="'https://finvasiaexpos.s3.eu-west-2.amazonaws.com/tradingsymbol/'+spreads.mn+'.svg'" :alt="spreads.mn">
                    </span>
                </div>
                <p class="m-0">
                    {{spreads.isinid}}
                </p>
                <span class="valueMid" :class="[{'green': isin.buy_increase_staus}, {'red': !isin.buy_increase_staus}]">{{isin.B}}</span>
                <span class="upLow" v-if="isin">
                    <span v-if="isin.other" v-bind:class="(((isin.B-(isin.other.closepx))*100)/(isin.other.closepx)).toFixed(2) > 0 ?  'green': 'red' ">
                        {{(((isin.B-(isin.other.closepx))*100)/(isin.other.closepx)).toFixed(2)}}%
                    </span>
                    <span v-if="isin.other" v-bind:class="(isin.B-(isin.other.closepx)).toFixed(2) > 0 ? 'green' :'red'">
                        {{(isin.B-(isin.other.closepx)).toFixed(2)}}
                    </span>
                </span>
            </li>
        </template>
        <!-- <div class="loader homechartloader py-5"></div> -->
        <div class="loader homechartloader py-5" v-if="Object.keys(allIsins).length == 0 && Object.keys(get_currencies).length == 0"></div>
        <div class="noRecordFound" v-if="Object.keys(allIsins).length == 0 && Object.keys(get_currencies).length > 0"> 
            <img src="../../../../static/fxView/images/search.svg" alt="no record found">
            <p>{{$t('thereIsNoRecord')}}</p>
        </div>
        <div class="loader homechartloader" v-if="Object.keys(allIsins).length == 0">Please wait loading..</div>
    </ul>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'

    // import { Const } from '@/plugins/vue-provider-cache/const.mod'
    export default {
        name: 'Price-index',
        mixins: [fxViewMixins],
        data() {
            return { 
                isinsListData:{},
                allIsins:{}
            }
        },
        watch:{
			fetchedIsins(newVal, oldVal) {
				if(newVal){
                    this.loader= false
                    this.allIsins= newVal
					this.isinsListData = Object.keys(newVal);
					this.currencyListSubscribe() 
				}else{
					return;
				}
			},

		},
        computed: {
			fetchedIsins(){
				return this.$store.getters['/GET_ISINS_LIST'];
			},
            fetchPriceFeed(){
                return this.$store.getters['/GET_PRICEFEED_DATA'];
            }
		},
        methods:{
            currencyListSubscribe(){
				let list = this.isinsListData;
				this.$websocket.sendWatchlist(list);
			},
            getAllIsins(){
                this._runGetIsinsList()
            },
            flotData(value){
                try{
                    if(parseFloat(parseFloat(value).toFixed(2).replace(/[.,]00$/, ""))){
                        return parseFloat(value).toFixed(2).replace(/[.,]00$/, "")
                    }else{
                        return parseFloat(value).toFixed(3).replace(/[.,]000$/, "") || '0'
                    }
                }catch(e){
                    return value
                }
            },
            currencyListSubscribe(){
				let list = this.isinsListData;
				this.$websocket.sendWatchlist(list);
			}
        },
        created(){
            this.getAllIsins()
            // console.log('price-index-section')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/price_index.vue